













/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleTitle"
	})
export default class ArticleTitle extends Vue {
	@Prop() private title: string;
	private changed(event: any) {
		this.$emit("update:title", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

}
